// extracted by mini-css-extract-plugin
export var actions = "_y-0";
export var actionsContainer = "_y-6";
export var border = "_y-1";
export var childFullHeight = "_y-d";
export var collapse = "_y-2";
export var content = "_y-8";
export var contentChild = "_y-c";
export var fullscreen = "_y-a";
export var headerContainer = "_y-3";
export var headerRow = "_y-5";
export var hidePadding = "_y-9";
export var noScrollX = "_y-e";
export var noScrollY = "_y-f";
export var optOutTopPadding = "_y-b";
export var pagePadding = "_y-7";
export var profile = "_y-g";
export var profileContainer = "_y-h";
export var profileImage = "_y-i";
export var profileMain = "_y-j";
export var profileSubtitle = "_y-l";
export var profileTitle = "_y-k";
export var tabsWrapper = "_y-4";
export var title = "_y-m";